// services/programService.js

import API from "../api/api";


export const programService = {
  getPrograms: async () => {
    const response = await API.get('/get_programs');
    return response.data.data || [];
  },
  
  deleteProgram: async (id) => {
    const response = await API.post('/delete_program', { id });
    return response.data;
  },
  createProgram: async (payload) => {
    const response = await API.post('/create_program', payload);
    return response.data;
  },
  
  updateProgram: async (payload) => {
    const response = await API.post('/update_program', payload);
    return response.data;
  },
  
};